import { render } from "./Possessions.vue?vue&type=template&id=0ca722bc"
import script from "./Possessions.vue?vue&type=script&lang=js"
export * from "./Possessions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__